<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <div>
          <Caption label="파트너쉽"></Caption>
        </div>

        <p style="margin-top:10px; font-weight: 300; font-size: 17px; color:#333">
          서비스가 안정화되고 성장하는 과정에서 든든한 개발팀이 되어드립니다
        </p>

        <div class="flex">
          <img width="480" class="pc" src="@/assets/images/main_partner.png" />
          <img
            width="288"
            class="mobile"
            src="@/assets/images/main_partner.png"
          />

          <div class="part">
            <div class="subtitle">
              <img width="20" src="@/assets/images/icon.png" />
              무상 유지보수
            </div>
            <p style="color: black; font-weight: 300; font-size: 18px">
              산출물에 대한 크리티컬한 오류에 대해선 무기한 무상으로 유지보수 해드립니다. 
              모든 서비스는 스케일링 되어 사용자가 급격하게 늘어나도 수용 가능하고 서비스 무중단을 보장합니다
            </p>
            <div class="subtitle">
              <img width="20" src="@/assets/images/icon.png" />
              기술 투자와 목표 공유
            </div>
            <p style="color: black; font-weight: 300; font-size: 18px">
              먼데이리스는 외주 개발 목표는 출시가 아닌 서비스 성공입니다.
              서비스 성공을 위해 기술적으로도 투자하고, 목표를 공유합니다.
              데이터를 체크하고 분석하며, 서비스 성공을 위해 노력합니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
  
<script>
import Caption from "./Caption.vue";
import CaptionGreen from "./CaptionGreen.vue";
import CaptionWhite from "./CaptionWhite.vue";
import client from "../client/client";

export default {
  components: {
    Caption,
    CaptionGreen,
    CaptionWhite,
  },
  mounted() {},
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: fit-content;
  position: relative;
  overflow: hidden;
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #ffffff;
}

.content {
  width: 1140px;
  max-width: 1140px;
  text-align: center;
}

.flex {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  margin-bottom: 50px;
}

.part {
  display: block;
  max-width: 532px;
  text-align: left;
  margin-left: 50px;
}

.subtitle {
  color: #215fe6;
  font-weight: 300;
  font-size: 20px;
  margin-top: 25px;
  margin-bottom: 15px;
}

.subtitle img {
  margin-right: 5px;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    padding-left: 40px;
    padding-right: 40px;
    justify-content: center;
    width: 100vw;
    height: fit-content;
    position: relative;
    overflow: hidden;
    background-color: #ffffff;
  }

  .content {
    width: 100%;
    text-align: center;
  }

  .flex {
    display: block;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 50px;
  }

  .part {
    display: inline;
    text-align: center;
  }

  .subtitle {
    color: #215fe6;
    font-weight: 300;
    font-size: 20px;
    margin-top: 55px;
    margin-bottom: 15px;
  }
}
</style>
  